import { render, staticRenderFns } from "./category-card-pack.vue?vue&type=template&id=4df01800&scoped=true"
import script from "./category-card-pack.vue?vue&type=script&lang=js"
export * from "./category-card-pack.vue?vue&type=script&lang=js"
import style0 from "./category-card-pack.vue?vue&type=style&index=0&id=4df01800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df01800",
  null
  
)

export default component.exports